export default __webpack_public_path__ + "static/media/Call_unanswered.f1a86dad.svg";